import React, { useState } from 'react';
import { services } from '../../../shared';
import { Grid, Heading } from '../../shared';
import './case-details.scss';
import { formatAddress, formatCurrency } from '../../../shared/utils';
import { questionDataType } from '../../../shared/types/constants';
export var CaseDetails = function (_a) {
    var applicationQuestions = _a.applicationQuestions, address = _a.address;
    var _b = useState(), fetchedAddress = _b[0], setFetchedAddress = _b[1];
    if (!fetchedAddress && applicationQuestions) {
        var questionAddress = applicationQuestions === null || applicationQuestions === void 0 ? void 0 : applicationQuestions.find(function (question) { return question.dataType === 'ADDRESS'; });
        if (questionAddress === null || questionAddress === void 0 ? void 0 : questionAddress.value)
            services
                .getAddress(Number(questionAddress.value))
                .then(function (result) { return setFetchedAddress(formatAddress(result.data)); });
    }
    var columns = [
        {
            id: 'wording',
            description: 'Details',
            render: function (column, row) {
                return React.createElement(React.Fragment, null, "".concat(row[column.id], ":"));
            },
        },
        {
            id: 'value',
            description: '',
            sort: false,
            render: function (column, row) {
                var displayValue = row[column.id];
                switch (row['dataType']) {
                    case questionDataType.currency:
                        displayValue = "\u00A3 ".concat(formatCurrency(row[column.id]));
                        break;
                    case questionDataType.address:
                        displayValue = fetchedAddress !== null && fetchedAddress !== void 0 ? fetchedAddress : formatAddress(address);
                        break;
                    case questionDataType.percentage:
                        displayValue = row[column.id] ? "".concat(row[column.id], " %") : '';
                        break;
                }
                return React.createElement(React.Fragment, null, displayValue);
            },
        },
    ];
    return (React.createElement("div", null,
        React.createElement("div", null,
            React.createElement(Heading, { extendClass: "c-case-details__header-title", level: "h2", title: "Details" })),
        React.createElement(Grid, { showHeaders: false, extendClass: "c-case-details", rowData: applicationQuestions, columns: columns, noRowsMessage: "No details are currently available." })));
};
